/**
 * Hero module
 */
(() => {
  const heroModule = document.querySelector('.module-hero');
  if (!heroModule) return;

  /**
   * Animate Bubble
   */
  const animateBubble = (imgGroup, bubbleId) => {
    imgGroup.querySelectorAll('.circle-small').forEach((bubble) => {
      const isActive = bubble.getAttribute('bubble-id') === bubbleId.toString();
      if (isActive) {
        bubble.classList.add('active');
      } else {
        bubble.classList.remove('active');
      }
    });
  };

  /**
   * Bubble animation
   * Does not include the pause when hovering
   */
  (() => {
    heroModule.querySelectorAll('.hero-images-group').forEach((imgGroup) => {
      const mainBubble = imgGroup.querySelector('.hero-images-bubbles .circle-main');
      let images = '';

      imgGroup.setAttribute('active-bubble', 0);

      let cycleInterval; // Declare cycleInterval here

      const totalBubbles = imgGroup.querySelectorAll('.hero-images-bubbles .circle-small').length;

      const cycleBubbles = () => {
        const currentActiveBubble = parseInt(imgGroup.getAttribute('active-bubble'), 10);
        const nextActiveBubble = (currentActiveBubble + 1) % totalBubbles;
        imgGroup.setAttribute('active-bubble', nextActiveBubble);
        animateBubble(imgGroup, nextActiveBubble);
      };

      // Start the cycle
      cycleInterval = setInterval(cycleBubbles, 2000); // Cycle every 2 seconds

      imgGroup.querySelectorAll('.hero-images-bubbles .circle-small').forEach((bubble, i) => {
        bubble.setAttribute('bubble-id', i);
        bubble.querySelector('img').setAttribute('bubble-id', i);
        images += `<img src="${bubble.querySelector('img').src}" bubble-id="${i}" />`;

        bubble.addEventListener('mouseover', () => {
          clearInterval(cycleInterval); // Stop the automatic cycle when manually hovering
          imgGroup.setAttribute('active-bubble', i);
          animateBubble(imgGroup, i);
        });

        bubble.addEventListener('mouseleave', () => {
          // Resume the automatic cycle when the mouse leaves the bubble
          cycleInterval = setInterval(cycleBubbles, 2000);
        });
      });

      mainBubble.innerHTML = /* html */ `
      <a href=""></a>
      ${images}
      `;

      // Hover over main bubble stops animation
      mainBubble.addEventListener('mouseover', () => {
        clearInterval(cycleInterval);
      });
      mainBubble.addEventListener('mouseleave', () => {
        cycleInterval = setInterval(cycleBubbles, 2000);
      });
    });
  })();
})();
